import React from 'react';
import PropTypes from 'prop-types';
import { useCombobox } from 'downshift';
import classNames from 'classnames';
import Error from '../error/Error';
import * as classes from './Combobox.module.scss';

function Combobox({ onInputChange, onChange, itemToString, options, label, error, loading }) {
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps
  } = useCombobox({
    items: options,
    onInputValueChange: ({ inputValue }) => onInputChange(inputValue),
    onSelectedItemChange: ({ selectedItem }) => onChange(selectedItem),
    itemToString
  });

  return (
    <div>
      <div className={classes.combobox}>
        <label className={classes.comboboxLabel} {...getLabelProps()}>
          {label}
        </label>

        <div className={classes.comboboxField} {...getComboboxProps()}>
          <input className={classes.comboboxInput} {...getInputProps()} />

          <button type="button" className={classes.comboboxButton} {...getToggleButtonProps()} aria-label="Toggle menu">
            &#8595;
          </button>
        </div>

        <ul className={classes.comboboxOptions} hidden={!isOpen} {...getMenuProps()}>
          {isOpen && loading ? (
            <span className={classes.comboboxSpinner} role="status" aria-hidden="true" />
          ) : (
            options.map((item, index) => {
              const itemClassName = classNames(classes.comboboxOption, {
                [classes.comboboxOption_highlighted]: highlightedIndex === index,
                [classes.comboboxOption_selected]: selectedItem === item
              });

              return (
                <li key={`${item}${index}`} className={itemClassName} {...getItemProps({ item, index })}>
                  {itemToString(item)}
                </li>
              );
            })
          )}
        </ul>
      </div>

      {error && <Error>{error?.message}</Error>}
    </div>
  );
}
Combobox.propTypes = {
  value: PropTypes.any,
  itemToString: PropTypes.func,
  onInputChange: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.node,
  error: PropTypes.object,
  loading: PropTypes.bool
};

export default Combobox;
